import { useLanguage } from '../contexts/LanguageContext';
import { LeadForm } from './LeadForm';
import { MessageSquare } from 'lucide-react';

export const LeadFormSection = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-12 sm:py-16 md:py-32 bg-slate-100" data-testid="lead-form-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-5 sm:p-8 md:p-12">
            <div className="text-center mb-6 sm:mb-8 md:mb-10">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-brand/10 rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <MessageSquare className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-brand" />
              </div>
              <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight text-primary">
                {t('leadForm.title')}
              </h2>
            </div>
            <LeadForm />
          </div>
        </div>
      </div>
    </section>
  );
};
